import { CurrentUser } from '../general/modules/user/currentUser';
import { ConsentSources } from '../constants/ConsentSources';
import { EmailConsentStates } from '../domains/valueObject/EmailConsentStates';
import { getHubApi } from '../general/modules/accountServiceApi/getAccountServiceApi';

export type GetConsentStateRequest = {
    token: string,
    suid: string
}

export type GetConsentStateResponse = {
    consent: EmailConsentStates,
    email: string | null
};

export default class ConsentState {
    public setState(state: boolean, email: string, source: ConsentSources) {
        const currentUser = CurrentUser.getInstance();
        const token = currentUser.getAuthToken();
        const suid = currentUser.getSuid();
        const entryPoint = currentUser.getEntryPoint();
        const hubApi = getHubApi();

        return hubApi.setConsentState(window.app.deviceIdentifier, {
            consent: state,
            source: source,
            email: email,
            entryPoint: entryPoint,
            suid: suid,
            token: token
        });
    }

    public async getConsentState(): Promise<GetConsentStateResponse> {
        const currentUser = CurrentUser.getInstance();
        const token = currentUser.getAuthToken();
        const suid = currentUser.getSuid();
        const hubApi = getHubApi();

        return await hubApi.getConsentState(window.app.deviceIdentifier, {
            suid: suid,
            token: token
        }) as GetConsentStateResponse;
    }
}
